import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import './utils/dragdroptouch-polyfill';
import App from './App';
// import reportWebVitals from './reportWebVitals';
import store from './store';
import './assets/styles/globals.scss';
import OfflineIndicator from './utils/hoc/OfflineIndicator';

const root = createRoot(document.getElementById('root'));

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <BrowserRouter>
      <OfflineIndicator />

      <App />
    </BrowserRouter>
  </Provider>,
  // </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
